<template>
  <div class="dir-hero">
    <div class="dir-hero-top">
      <!-- Logo: iniciales por defecto, cámara en hover -->
      <div class="dir-hero-logo" @click="$emit('upload-logo')">
        <img
          v-if="business.image"
          :src="business.image"
          class="dir-hero-logo-img"
          alt="Logo"
        />
        <template v-else>
          <span class="dir-hero-logo-initials">{{
            getInitials(business.name)
          }}</span>
          <div class="dir-hero-logo-overlay">
            <i class="el-icon-camera"></i>
          </div>
        </template>
      </div>

      <div class="dir-hero-info">
        <h3 class="dir-hero-name">{{ business.name }}</h3>
        <div class="dir-hero-meta-line">
          <span
            v-if="business.contact_type"
            class="dir-hero-type"
            :class="business.contact_type === 1 ? 'is-client' : 'is-provider'"
          >
            {{ business.contact_type === 1 ? "Cliente" : "Proveedor" }}
          </span>
          <span v-if="business.contact_type && cityName" class="dir-hero-dot"
            >·</span
          >
          <span v-if="cityName" class="dir-hero-city">{{ cityName }}</span>
        </div>
        <p v-if="business.email" class="dir-hero-email">
          <i class="el-icon-message"></i>{{ business.email }}
        </p>
      </div>
    </div>

    <!-- Stats row -->
    <div class="dir-hero-stats">
      <div class="dir-hero-stat">
        <span class="dir-hero-stat-label">Contactos</span>
        <span class="dir-hero-stat-value">{{ contactsCount }}</span>
      </div>
      <div class="dir-hero-stat dir-hero-stat-accent">
        <span class="dir-hero-stat-label">Facturado</span>
        <span class="dir-hero-stat-value"
          >${{ formatAmount(business.invoices_earnings) }}</span
        >
      </div>
      <div class="dir-hero-stat">
        <span class="dir-hero-stat-label">Cotizaciones</span>
        <span class="dir-hero-stat-value">{{ quotesCount }}</span>
      </div>
    </div>

    <!-- Profile completeness (integrated in hero) -->
    <div class="dir-hero-completeness">
      <div class="dir-hero-completeness-header">
        <span class="dir-hero-completeness-label">Perfil completo</span>
        <span class="dir-hero-completeness-pct">{{ completeness }}%</span>
      </div>
      <div class="dir-hero-completeness-bar">
        <div
          class="dir-hero-completeness-fill"
          :style="{ width: completeness + '%' }"
        ></div>
      </div>
      <p v-if="missingFields.length" class="dir-hero-completeness-hint">
        Falta: {{ missingFields.join(", ") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyHero",
  props: {
    business: { type: Object, required: true },
    contactsCount: { type: Number, default: 0 },
    quotesCount: { type: Number, default: 0 }
  },
  computed: {
    cityName() {
      return this.business.city ? this.business.city.name : null;
    },
    completeness() {
      if (!this.business) return 0;
      const fields = [
        { key: "name", label: "razón social" },
        { key: "tradename", label: "nombre comercial" },
        { key: "email", label: "correo" },
        { key: "phone", label: "teléfono" },
        { key: "address", label: "dirección" },
        { key: "document", label: "documento" },
        { key: "document_type", label: "tipo documento" },
        { key: "contact_type", label: "tipo empresa" },
        { key: "city_id", label: "ciudad" },
        { key: "web", label: "sitio web" },
        { key: "image", label: "logo" }
      ];
      const filled = fields.filter(f => this.business[f.key]).length;
      return Math.round((filled / fields.length) * 100);
    },
    missingFields() {
      if (!this.business) return [];
      const fields = [
        { key: "phone", label: "teléfono" },
        { key: "web", label: "sitio web" },
        { key: "city_id", label: "ciudad" },
        { key: "address", label: "dirección" },
        { key: "image", label: "logo" },
        { key: "document", label: "documento" }
      ];
      return fields.filter(f => !this.business[f.key]).map(f => f.label);
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return "??";
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.substring(0, 2).toUpperCase();
    },
    formatAmount(value) {
      if (!value) return "0.00";
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
